import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 24,
    height: 24,
    // No hardcoded color here — inherit from the parent SidebarItem so this
    // icon follows the same grey (default/hover) / blue-on-selected
    // behavior as every other sidebar entry (see Sidebar.tsx's
    // `.MuiSvgIcon-root { color: inherit }` rule).
    color: 'inherit',
  },
});

export const CustomSecurityIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
    >
      <ellipse cx="32" cy="61" rx="20.125" ry="3" opacity="0.3" fill="currentColor" />

      <path
        fill="currentColor"
        d="M48,52H17c-2.209,0-4-1.791-4-4V8c0-2.209,1.791-4,4-4h21.311c1.06,0,2.077,0.421,2.827,1.17
        l9.689,9.68C51.578,15.601,52,16.619,52,17.68V48C52,50.209,50.209,52,48,52z"
      />

      <path
        fill="currentColor"
        opacity="0.3"
        d="M13,8v18c2.762,0,5-2.238,5-5V9.652c0-0.42,0.264-0.795,0.66-0.934 
        C20.605,8.033,22,6.18,22,4h-5C14.791,4,13,5.791,13,8z"
      />

      <path
        fill="currentColor"
        opacity="0.15"
        d="M52,48V25c-2.762,0-5,2.238-5,5v16c0,0.552-0.448,1-1,1h-9c-2.762,0-5,2.238-5,5h16 
        C50.209,52,52,50.209,52,48z"
      />

      <line
        x1="16.5"
        x2="16.5"
        y1="9.5"
        y2="16.5"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        fill="currentColor"
        d="M50.827,14.851l-9.689-9.68C40.806,4.839,40.417,4.584,40,4.389V12c0,2.209,1.791,4,4,4h7.616
        C51.42,15.579,51.162,15.185,50.827,14.851z"
      />

      <path
        fill="currentColor"
        d="M25,24h15c1.105,0,2-0.895,2-2v0c0-1.105-0.895-2-2-2H25c-1.105,0-2,0.895-2,2v0
        C23,23.105,23.895,24,25,24z"
      />

      <path
        fill="currentColor"
        d="M25,32h15c1.105,0,2-0.895,2-2v0c0-1.105-0.895-2-2-2H25c-1.105,0-2,0.895-2,2v0
        C23,31.105,23.895,32,25,32z"
      />

      <path
        fill="currentColor"
        d="M25,40h15c1.105,0,2-0.895,2-2v0c0-1.105-0.895-2-2-2H25c-1.105,0-2,0.895-2,2v0
        C23,39.105,23.895,40,25,40z"
      />
    </svg>
  );
};
